import React from 'react';
import {
  styled,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import { PropTypes } from 'prop-types';
import { darkTheme } from 'daaas-ui';

// Components
import { Grid, Paper, Box } from '@mui/material';
import ContentContainer from '../Layout/ContentContainer';

// Images
import dasShapesChaos from '../../assets/images/DAS-Shapes-Chaos.svg';

const Root = styled('div')(({ theme }) => ({
  '& .banner': {
    textAlign: 'left',
    boxSizing: 'border-box',
    borderRadius: 0,
    position: 'relative',
  },

  '& .banner__content': {
    padding: theme.spacing(2, 0),
  },

  '& .banner__shapes': {
    display: 'flex',
    alignItems: 'center',
    backgroundImage: `url(${dasShapesChaos})`,
    backgroundPosition: 'left',
    backgroundRepeat: 'repeat',
    backgroundSize: '100%',
    width: '100%',
  },

  '& .banner__container': {
    width: '100vw',
    maxWidth: '100%',
    height: '30rem',
    position: 'absolute',
    top: '-50px',
    overflowX: 'hidden',
    pointerEvents: 'none',
  },

  '& .banner__leftGraphic': {
    height: '30rem',
    position: 'absolute',
    top: '0',
    left: '-28rem',
    display: 'none',
    [theme.breakpoints.up('xl')]: {
      display: 'block',
    },
  },
  '& .banner__rightGraphic': {
    height: '30rem',
    position: 'absolute',
    top: '0',
    right: '-28rem',
    display: 'none',
    [theme.breakpoints.up('xl')]: {
      display: 'block',
    },
  },
  '@media (min-width: 1800px)': {
    '& .banner__leftGraphic': {
      left: '-25rem',
    },
    '& .banner__rightGraphic': {
      right: '-25rem',
    },
  },
}));

export default function Banner({ children }) {
  return (
    <Root>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={darkTheme}>
          <Paper className="banner">
            <ContentContainer paddingBottom={false}>
              <Grid container justifyContent="space-between">
                <Grid item xs={12} md={7} lg={6} className="banner__content">
                  {children}
                </Grid>
                <Grid item xs={0} md={5} lg={6} className="banner__shapes" />
              </Grid>
            </ContentContainer>
            <Box className="banner__container">
              <img
                src={dasShapesChaos}
                alt=""
                className="banner__leftGraphic"
                loading="lazy"
              />
              <img
                src={dasShapesChaos}
                alt=""
                className="banner__rightGraphic"
                loading="lazy"
              />
            </Box>
          </Paper>
        </ThemeProvider>
      </StyledEngineProvider>
    </Root>
  );
}

Banner.propTypes = {
  children: PropTypes.node.isRequired,
};
